export default __webpack_public_path__ + "static/media/90s_level_won.56c60825.mp3";